module.exports = __webpack_public_path__ + "static/img/img18.32a0b9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zone/img18.png
// module id = tdH7
// module chunks = 1